const AllowedTimeBeforeShift = 'AllowedTimeBeforeShift';
const ShiftMayOverlap = 'ShiftMayOverlap';
const EmployeNotOnProbation = 'EmployeNotOnProbation';
const ScheduleRules = 'ScheduleRules';
const SkillsAndCertifs = 'SkillsAndCertifs';
const JobTransferSetValidation = 'JobTransferSetValidation';
const SameDuration = 'SameDuration';
const RestBetweenShifts = 'RestBetweenShifts';
const EmployeeEligibility = 'EmployeeEligibility';
const MultipleShiftOnSameDay = 'MultipleShiftOnSameDay';
const MaxHoursInRollingPeriod = 'MaxHoursInRollingPeriod';
const PaycodeOverlap = 'PaycodeOverlap';
const EmployeeRestriction = 'EmployeeRestriction'
const SwapPeriod = 'SwapPeriod'
const SameDayPaycode = "SameDayPaycode"
const VtoOverlap = 'VtoOverlap'
const EmployeeEligibilityRelativeToShift = 'EmployeeEligibilityRelativeToShift'
const MaxBiWeeklyHours = 'MaxBiWeeklyHours'

export default Object.freeze({
    [AllowedTimeBeforeShift]: 1,
    [ShiftMayOverlap]: 2,
    [EmployeNotOnProbation]: 4,
    [ScheduleRules]: 5,
    [SkillsAndCertifs]: 6,
    [JobTransferSetValidation]: 8,
    [SameDuration]: 9,
    [RestBetweenShifts]: 10,
    [EmployeeEligibility]: 11,
    [MultipleShiftOnSameDay]: 12,
    [MaxHoursInRollingPeriod]: 13,
    [PaycodeOverlap]: 14,
    [EmployeeRestriction]: 15,
    [SwapPeriod]: 16,
    [SameDayPaycode]: 17,
    [EmployeeEligibilityRelativeToShift]: 18,
    [MaxBiWeeklyHours]: 19,
    [VtoOverlap]: 1000,
});

export const ValidationTypeName = Object.freeze({
    1: AllowedTimeBeforeShift,
    2: ShiftMayOverlap,
    4: EmployeNotOnProbation,
    5: ScheduleRules,
    6: SkillsAndCertifs,
    8: JobTransferSetValidation,
    9: SameDuration,
    10: RestBetweenShifts,
    11: EmployeeEligibility,
    12: MultipleShiftOnSameDay,
    13: MaxHoursInRollingPeriod,
    14: PaycodeOverlap,
    15: EmployeeRestriction,
    16: SwapPeriod,
    17: SameDayPaycode,
    18: EmployeeEligibilityRelativeToShift,
    19: MaxBiWeeklyHours,
    1000: VtoOverlap,
});
